export const AWS_MARKETPLACE_URL = 'https://aws.amazon.com/marketplace/pp/prodview-jbay5iyfmu6ui';
export const NO_CACHE_HEADER = {'X-Cache-Control': 'max-age=0'};
export const AGENT_TROUBLESHOOTING_GUIDE_URL = 'https://docs.netapp.com/us-en/bluexp-setup-admin/task-troubleshoot-connector.html';
